/* Blog editorial: tidies article rich text so every post reads cleanly,
   regardless of how it was pasted into Shopify. Progressive enhancement:
   the page is fully readable without this script. */
(function () {
  'use strict';

  var CALLOUT = /^(pro tip|tip|example|note|important|key takeaway|takeaway|remember|warning|caution|in short|summary|bottom line)s?\s*:?\s*$/i;
  var FAQ_HEADING = /\bfaqs?\b|frequently asked/i;

  function text(el) {
    return (el.textContent || '').replace(/ /g, ' ').replace(/\s+/g, ' ').trim();
  }

  function onlyChildEl(p) {
    // Returns the single element child when the paragraph contains nothing else but whitespace
    var el = null;
    for (var i = 0; i < p.childNodes.length; i++) {
      var n = p.childNodes[i];
      if (n.nodeType === 3) { if (n.textContent.replace(/ /g, ' ').trim()) return null; }
      else if (n.nodeType === 1) {
        if (n.tagName === 'BR') continue;
        if (el) return null;
        el = n;
      }
    }
    return el;
  }

  function isBoldOnly(p) {
    var el = onlyChildEl(p);
    while (el && /^(SPAN|U)$/.test(el.tagName)) el = onlyChildEl(el);
    return !!el && /^(STRONG|B)$/.test(el.tagName);
  }

  var PRICE = /(\$|AUD|A\$|NZ\$)\s?\d/;
  var EMBEDS = '[id^="product-component"], [id^="collection-component"], .shopify-buy-frame, iframe[name^="frame-product"], iframe[name^="frame-collection"], [data-product-id], [data-product-handle], [class*="product-card"], [class*="product-grid"], [class*="products-grid"], [class*="product-carousel"], [class*="product-slider"], [class*="product-list"]';

  // Remove product cards / grids / carousels / Buy Button embeds from the post body.
  // A product link is treated as a card only if it includes an image; the removal climbs to the
  // smallest wrapper around the cards but never past a heading or a block of real body text.
  function removeProducts(root) {
    function top(el) {
      var box = el, n = el.parentElement;
      while (n && n !== root) {
        var links = n.querySelectorAll('a[href*="/products/"]').length || 1;
        if (n.querySelector('h1, h2, h3, h4') || text(n).length > 160 * links + 120) break;
        box = n; n = n.parentElement;
      }
      return box;
    }
    root.querySelectorAll(EMBEDS).forEach(function (el) { if (el.isConnected && root.contains(el)) top(el).remove(); });
    root.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      if (!a.isConnected) return;
      var box = top(a);
      if (!box.querySelector('img, picture')) return;
      if (box === a || box.tagName === 'P') { if (!PRICE.test(text(box))) return; }
      box.remove();
    });
    // Drop scroll wrappers left empty
    root.querySelectorAll('div, section').forEach(function (d) {
      if (!text(d) && !d.querySelector('img, iframe, video, table, svg, picture')) d.remove();
    });
  }

  function tidy(root) {
    var clean = root.classList.contains('be-content--clean');
    if (root.hasAttribute('data-hide-products')) removeProducts(root);

    // Content wrapped in one outer <div> (common with pasted HTML): unwrap so the rules below apply
    while (root.children.length === 1 && root.firstElementChild.tagName === 'DIV' && !root.firstElementChild.className.match(/be-/)) {
      var only = root.firstElementChild;
      while (only.firstChild) root.insertBefore(only.firstChild, only);
      only.remove();
    }

    // 1. Blank paragraphs (&nbsp;, lone <br>) used as spacers
    if (clean) {
      root.querySelectorAll('p').forEach(function (p) {
        if (!text(p) && !p.querySelector('img,iframe,video,svg,picture,input')) p.classList.add('be-blank');
      });
    }

    // 2. Tables scroll on small screens
    root.querySelectorAll('table').forEach(function (t) {
      if (t.parentElement && t.parentElement.classList.contains('be-table')) return;
      // Tables pasted without a header row: treat a short first row as the header
      if (!t.querySelector('thead, th') && t.rows.length > 2) {
        var r0 = t.rows[0];
        var short = Array.prototype.every.call(r0.cells, function (c) { return text(c).length <= 40; });
        if (short) r0.classList.add('be-thead');
      }
      var w = document.createElement('div');
      w.className = 'be-table';
      t.parentNode.insertBefore(w, t);
      w.appendChild(t);
    });

    // 3. Bold one-line paragraphs act as sub-headings; "Tip:" / "Example:" become callouts
    root.querySelectorAll(':scope > p').forEach(function (p) {
      var t = text(p);
      if (!t) return;
      if (isBoldOnly(p) && t.length <= 110 && !/[.!]$/.test(t) && p.nextElementSibling) {
        p.classList.add('be-subhead');
        return;
      }
      var first = p.firstElementChild;
      if (first && /^(STRONG|B)$/.test(first.tagName) && p.firstChild === first && CALLOUT.test(text(first)) && t.length > text(first).length + 3) {
        p.classList.add('be-callout');
      }
    });

    // 4. Any FAQ block still inside the article body becomes an accordion
    root.querySelectorAll(':scope > h2').forEach(function (h2) {
      if (!FAQ_HEADING.test(text(h2))) return;
      var nodes = [];
      var n = h2.nextElementSibling;
      while (n && n.tagName !== 'H2') { nodes.push(n); n = n.nextElementSibling; }
      var isQ = function (el) {
        return /^H[3-6]$/.test(el.tagName) || (el.tagName === 'P' && el.classList.contains('be-subhead')) ||
          (el.tagName === 'P' && isBoldOnly(el) && /\?$/.test(text(el)));
      };
      if (!nodes.some(isQ)) return;
      var list = document.createElement('div');
      list.className = 'be-faq-inline';
      var current = null;
      nodes.forEach(function (el) {
        if (isQ(el)) {
          current = document.createElement('details');
          var s = document.createElement('summary');
          s.innerHTML = '<span>' + text(el).replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; }) + '</span><span class="be-faq__icon" aria-hidden="true"></span>';
          var a = document.createElement('div');
          a.className = 'be-faq__a';
          current.appendChild(s);
          current.appendChild(a);
          list.appendChild(current);
          el.remove();
        } else if (current) {
          current.lastChild.appendChild(el);
        }
      });
      h2.parentNode.insertBefore(list, h2.nextSibling);
      // Anything before the first question stays above the accordion
      nodes.forEach(function (el) { if (el.isConnected && el.parentNode === root) root.insertBefore(el, list); });
    });
  }

  function share(root) {
    var btn = root.querySelector('[data-be-copy]');
    if (!btn || !navigator.clipboard) { if (btn) btn.hidden = true; return; }
    btn.addEventListener('click', function () {
      navigator.clipboard.writeText(btn.getAttribute('data-be-copy')).then(function () {
        var msg = root.querySelector('.be-share__copied');
        if (!msg) return;
        msg.hidden = false;
        setTimeout(function () { msg.hidden = true; }, 2000);
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll('.be-content:not([data-be-ready])').forEach(function (el) {
      el.setAttribute('data-be-ready', '');
      tidy(el);
    });
    (scope || document).querySelectorAll('.be-share').forEach(share);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
